import { defineStore } from 'pinia'

export const CurrentYearCalendar = defineStore('zn_cal_year', {
    state: () => {
        return { zn_cal_year: null }
    },
    actions: {
        get() {
            return this.zn_cal_year
        },
        set(data) {
            this.zn_cal_year = data
        }
    },
})